import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import WhatIsSpreadsheet from "@/pages/article/what-is-sugargoo-spreadsheet/page";
import SugargooReview2026 from "@/pages/article/sugargoo-review-2026/page";
import SugargooShippingCost from "@/pages/article/sugargoo-shipping-cost/page";
import SugargooCouponDiscount from "@/pages/article/sugargoo-coupon-discount/page";
import IsSugargooLegitSafe from "@/pages/article/is-sugargoo-legit-safe/page";
import SugargooWarehouseGuide from "@/pages/article/sugargoo-warehouse-guide/page";
import BestSugargooSpreadsheet from "@/pages/article/best-sugargoo-spreadsheet-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-sugargoo-spreadsheet",
    element: <WhatIsSpreadsheet />,
  },
  {
    path: "/article/sugargoo-review-2026",
    element: <SugargooReview2026 />,
  },
  {
    path: "/article/sugargoo-shipping-cost",
    element: <SugargooShippingCost />,
  },
  {
    path: "/article/sugargoo-coupon-discount",
    element: <SugargooCouponDiscount />,
  },
  {
    path: "/article/is-sugargoo-legit-safe",
    element: <IsSugargooLegitSafe />,
  },
  {
    path: "/article/sugargoo-warehouse-guide",
    element: <SugargooWarehouseGuide />,
  },
  {
    path: "/article/best-sugargoo-spreadsheet-2026",
    element: <BestSugargooSpreadsheet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;